import { LevelUuid } from '@openeducation/oe-rn-shared-types';

export const getLevelUuidFromLevelNumber = (
  levelNumber?: string
): LevelUuid => {
  switch (levelNumber) {
    case '2':
      return LevelUuid.TWO;
    case '3':
      return LevelUuid.THREE;
    case '4':
      return LevelUuid.FOUR;
    case '5':
      return LevelUuid.FIVE;
    case '6':
      return LevelUuid.SIX;
    case '7':
      return LevelUuid.SEVEN;
    case '8':
      return LevelUuid.EIGHT;
    case '1':
    default:
      return LevelUuid.ONE;
  }
};
